import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, Eyebrow } from "./Reveal";
import { STANDARD_SERVICE } from "../lib/site";

const FAQS = [
    {
        q: 'What does "stump size" mean on the price list?',
        a: 'Measure straight across the stump at ground level — the widest point where the root flare meets the dirt. Match that number to the size table. Not sure? Send a photo with your free quote and we\'ll size it for you.',
        testid: "faq-item-size",
    },
    {
        q: "What's included in the standard service?",
        a: STANDARD_SERVICE + " That's the base price you see on the size table — nothing hidden.",
        testid: "faq-item-standard",
    },
    {
        q: "My stump is in the backyard / near a fence / on a slope. Can you still get to it?",
        a: "Yes. Access and difficulty are built into the price list: backyard with easy access is +$25, narrow or difficult access +$50–$100, close to a fence or building +$50–$150, slopes +$50–$150, and so on. Every surcharge is published before you book.",
        testid: "faq-item-access",
    },
    {
        q: "Do you haul the wood chips away?",
        a: "Standard service rakes the grindings back into the hole. For full cleanup we offer chip/debris haul-off (+$50–$150), topsoil (+$50–$100), seed + straw (+$50–$100), or complete lawn restoration (+$100–$200+).",
        testid: "faq-item-cleanup",
    },
    {
        q: "How fast can you get here?",
        a: "That's our same-week guarantee: call this week and we grind this week. We run Monday through Saturday, 7:00 AM – 6:00 PM.",
        testid: "faq-item-speed",
    },
    {
        q: "How do I pay?",
        a: "We accept cash and card, with other payment options available. Payment is due when the job is done and you're happy with it.",
        testid: "faq-item-payment",
    },
];

const FAQSection = () => (
    <section className="max-w-4xl mx-auto px-5 sm:px-8 py-24" data-testid="faq-section">
        <Reveal className="mb-12 text-center">
            <Eyebrow className="mb-4">Straight answers</Eyebrow>
            <h2 className="font-display font-black uppercase text-brand-cream text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
                Questions, answered.
            </h2>
        </Reveal>

        <Reveal delay={0.1}>
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion-container">
                {FAQS.map((f, i) => (
                    <AccordionItem key={i} value={`faq-${i}`} className="border-brand-line">
                        <AccordionTrigger
                            data-testid={f.testid}
                            className="font-display font-bold uppercase text-lg sm:text-xl tracking-wide text-brand-cream hover:text-brand-amber hover:no-underline text-left"
                        >
                            {f.q}
                        </AccordionTrigger>
                        <AccordionContent className="text-brand-sage text-base leading-relaxed">
                            {f.a}
                        </AccordionContent>
                    </AccordionItem>
                ))}
            </Accordion>
        </Reveal>
    </section>
);

export default FAQSection;
